import removeSyncRequestOperation from 'owa-service/lib/operation/removeSyncRequestOperation';
import RemoveSyncRequestRequest from 'owa-service/lib/contract/RemoveSyncRequestRequest';
import RemoveSyncRequestResponse from 'owa-service/lib/contract/RemoveSyncRequestResponse';
import SyncRequest from 'owa-service/lib/contract/SyncRequest';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';

export async function removeSyncRequest(
    syncRequest: SyncRequest
): Promise<RemoveSyncRequestResponse> {
    let request: RemoveSyncRequestRequest = {
        Header: getJsonRequestHeader(),
        Id: syncRequest.Id,
    };

    let response: RemoveSyncRequestResponse = await removeSyncRequestOperation(request);
    return response;
}
